import styled from "styled-components"
import { GatsbyImage } from "gatsby-plugin-image"


export const NoResultsContainer = styled.div`
    display: flex;
    background-color: #fff;
    padding: 45px;
    border-radius: 25px;
    align-items: center;

    @media only screen and (max-width: 780px) {
        padding: 30px 25px;
    }
`

export const ImageContainer = styled.div`
    min-width: 80px;
    margin-right: 20px;

    @media only screen and (max-width: 780px) {
        min-width: 40px;
    }
`

export const Emoji = styled(GatsbyImage)`
    width: 75px;
    height: 75px;

    @media only screen and (max-width: 780px) {
        width: 36px;
        height: 36px;
    }
`

export const TextContainer = styled.div``

export const MobileTextContainer = styled.div`
    display: flex;
    margin-bottom: 10px;
   
`

export const NoResultsHeader = styled.h2`
    ${({ theme: { typography } }) => typography.desktop.h2};
    margin-bottom: 6px;

    @media only screen and (max-width: 780px) {
        ${({ theme: { typography } }) => typography.mobile.h2};
        padding-top: 2px;
    }
`

export const NoResultsText = styled.p`
    ${({ theme: { typography } }) => typography.desktop.body};
    color: ${({ theme: { colors } }) => colors.darkGrey};
    font-weight: ${({ theme: { fontWeight } }) => fontWeight.regular};
    @media only screen and (max-width: 780px) {
        ${({ theme: { typography } }) => typography.mobile.body};
        color: ${({ theme: { colors } }) => colors.darkGrey};
        font-weight: ${({ theme: { fontWeight } }) => fontWeight.regular};
    }
`

export const MostPopularTextContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    margin-top: 60px;
    margin-bottom: 20px;

    @media only screen and (max-width: 780px) {
        margin-top: 40px;
        margin-bottom: 15px;
    }
`
export const MostPopularText = styled.div`
    ${({ theme: { typography } }) => typography.desktop.excerpt};
    color: ${({ theme: { colors } }) => colors.black};
    font-weight: ${({ theme: { fontWeight } }) => fontWeight.semiBold};
    margin-right: 30px;

    @media only and (max-width: 780px){
        ${({ theme: { typography } }) => typography.mobile.body};
        color: ${({ theme: { colors } }) => colors.darkGrey};
    }
`

export const DividerLine = styled.div`
    height: 1px;
    background-color: ${({ theme: { colors } }) => colors.midGrey};
    flex-grow: 1;
`